module.exports = __webpack_public_path__ + "img/icon-date.57217739.svg";